import { useState, useMemo } from "react";
import { workflows as mockData } from "../data";
import WorkflowFilters from "./WorkflowFilters";
import WorkflowGrid from "./WorkflowGrid";
import { WorkflowTemplate } from "../types";

export default function WorkflowLibraryPage() {
  const [search, setSearch] = useState("");
  const [category, setCategory] = useState("");
  const [sort, setSort] = useState("popular");

  const filtered = useMemo(() => {
    let result = [...mockData];

    if (search) {
      const terms = search.toLowerCase().split(" ");

      result = result.filter((w) =>
        terms.every(
          (term) =>
            w.name.toLowerCase().includes(term) ||
            w.description.toLowerCase().includes(term) ||
            w.category.toLowerCase().includes(term) ||
            w.tags.some((tag) => tag.toLowerCase().includes(term))
        )
      );
    }

    if (category) {
      result = result.filter((w) => w.category === category);
    }

    if (sort === "popular") {
      result.sort((a, b) => b.usageCount - a.usageCount);
    } else if (sort === "newest") {
      result.sort(
        (a, b) =>
          new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
      );
    } else if (sort === "mostUsed") {
      result.sort((a, b) => b.usageCount - a.usageCount);
    }

    return result;
  }, [search, category, sort]);

  const handleUseTemplate = (workflow: WorkflowTemplate) => {
    console.log("Duplicating workflow:", workflow);
    // TODO: API call to duplicate template
  };

  return (
    <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
      <div
        style={{
          display: "flex",
          gap: "20px",
          alignItems: "center",
          marginBottom: "20px",
          fontSize: "14px",
          color: "#6B7280",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ color: "#F59E0B" }}>🔥</span>
          <span>Popular</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ color: "#3B82F6" }}>⭐</span>
          <span>Recommended</span>
        </div>

        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <span style={{ color: "#10B981" }}>✔</span>
          <span>Verified</span>
        </div>
      </div>
      <WorkflowFilters
        search={search}
        setSearch={setSearch}
        category={category}
        setCategory={setCategory}
        sort={sort}
        setSort={setSort}
      />

      <WorkflowGrid workflows={filtered} onUse={handleUseTemplate} />
    </div>
  );
}
